import React,{useEffect,useState,useRef} from "react";
import styles from "./PlanATripPaymentMain.module.css";

import { connect } from "react-redux";
import changeDetails from "../../../store/Actions/DetailsAction";

import { Link, useHistory } from "react-router-dom";
import { createVisaApplicationApi } from "../../../config/createVisaApplicationApi";
import { paymentPopupApi } from "../../../config/paymentPopupApi";

import changeLogin from "../../../store/Actions/LoginAction";

import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BsCheckAll } from "react-icons/bs";
import { BiError } from "react-icons/bi";


import Radio from "@material-ui/core/Radio";

import moment from "moment";


import bank1 from "../../../assets/images/bank1.png";
import bank2 from "../../../assets/images/bank2.png";
import bank3 from "../../../assets/images/bank3.png";
import bank4 from "../../../assets/images/bank4.PNG";

import lessthan from '../../../assets/images/lessthan.svg'

function PlanATripPaymentMain(props) {
  const country = props.details.country;
  const country_id = props.details.country_id;
  const persons = props.details.persons;
  const visa_type = props.details.visa_type;
  const visa_id = props.details.visa_id;
  const embassy_fees = props.details.embassy_fees;
  const normal_fees = props.details.normal_fees;
  const express_fees = props.details.express_fees;
  const stay_duration = props.details.stay_duration;
  const persons_details = props.details.persons_details;
  const date1 = moment(new Date(props.details.travel_date));
  const travel_date = date1.format("DD/MM/YYYY");
  const date2 = moment(new Date(props.details.return_date));
  const return_date = date2.format("DD/MM/YYYY");

  const total = props.details.total;
  const service_fees = props.details.total - props.details.embassy_fees;
  const service = props.details.service;

  const travel_date1 = date1.toISOString();
  const return_date1 = date2.toISOString();

  const login = props.login

  const history = useHistory();
  const payBtn = useRef("");
  const [id, setId] = useState("");
  const [token, setToken] = useState("");
  const [bank, setBank] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (country === undefined) {
      history.goBack();
    }

    function getWithExpiry(key) {
      const itemStr = localStorage.getItem(key);
      if (!itemStr) {
        return null;
      }
      const item = JSON.parse(itemStr);
      setId(item.value.user_data._id);
      setToken(item.value.token);
    }
    getWithExpiry("userData");
  }, [login]);



  console.log(props.details);

  if (props.details.total === 0) {
    // history.push("/dashboard/plan-a-trip");
  }

  
  const pay = () => {
    if (bank === "") {
      toast.error(
        <span style={{ display: "flex", alignItems: "center" }}>
          <BiError size="30" style={{ marginRight: "10px" }} />
          Please Select Payment Method!
        </span>,
        {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        }
      );
    } else {
        setLoading(true);
        payBtn.current.setAttribute("disabled", "disabled");
        const visa = async () => {
          const visa = await createVisaApplicationApi(
            {
              travellers_count: persons,
              owner: id,
              destination: country_id,
              visa_package: visa_id,
              return_date: return_date1,
              departure_date: travel_date1,
              cost: {
                embassy_fee: embassy_fees,
                service_charges: service_fees,
                total_cost: total,
              },
              plan_type: service.toUpperCase(),
              payment_method: "CARD",
              payment_gateway: bank.toUpperCase(),
              created_via: "HOMEPAGE",
            },
            token
          );
  
          if (visa.error) {
            toast.error(
              <span style={{ display: "flex", alignItems: "center" }}>
                <BiError size="30" style={{ marginRight: "10px" }} />
                {visa.error.response.data.message}
              </span>,
              {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
              }
            );
            setLoading(false);
            payBtn.current.removeAttribute("disabled");
          } else if (visa.data) {
  
  
  
            const payment = async () => {
              const payment = await paymentPopupApi(
                visa.data.data._id,
                token,
                visa.data.data.payment_gateway.toLowerCase(),
                `http://visapro1.netlify.app/dashboard/plan-a-trip/payment/successful?provider=${bank}`
                // `http://localhost:3000/dashboard/plan-a-trip/payment/successful?provider=${bank}`
                
  
              );
  
              if (payment.error) {
                toast.error(
                  <span style={{ display: "flex", alignItems: "center" }}>
                    <BiError size="30" style={{ marginRight: "10px" }} />
                    {payment.error.response.data.message}
                  </span>,
                  {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                  }
                );
                setLoading(false);
                payBtn.current.removeAttribute("disabled");
              } else if (payment.data) {
                window.location.replace(payment.data.data.link)
                setLoading(false);
                payBtn.current.removeAttribute("disabled");
              }
            };
            payment();
          }
        };
        visa();
    }
  };
  
  return (
    <div>
      <h2 className={styles.head}>Make Payment</h2>
      <div className={styles.boxTop}>
        <div className={styles.eachBox}>
          <div>
            <h2 className={styles.boxHead}>Destination</h2>
            <h2 className={styles.boxPera}>{country}</h2>
          </div>
        </div>

        <span className={styles.line}></span>

        <div className={styles.eachBox}>
          <div>
            <h2 className={styles.boxHead}>Visa type</h2>
            <h2 className={styles.boxPera}>30 days single entry</h2>
          </div>
        </div>
        <span className={styles.line}></span>

        <div className={styles.eachBox}>
          <div>
            <h2 className={styles.boxHead}>Departure</h2>
            <h2 className={styles.boxPera}>{travel_date}</h2>
          </div>
        </div>
        <span className={styles.line}></span>

        <div className={styles.eachBox}>
          <div>
            <h2 className={styles.boxHead}>Return</h2>
            <h2 className={styles.boxPera}>{return_date}</h2>
          </div>
        </div>
        <span className={styles.line}></span>

        <div className={styles.eachBox}>
          <div>
            <h2 className={styles.boxHead}>Travellers</h2>
            <h2 className={styles.boxPera}>{persons}</h2>
          </div>
        </div>
      </div>

      <div className={styles.mainBox1}>
      

        <>
        <div className={styles.box1FirstCont}>
          <p className={styles.badge}>3 of 5</p>
          <p className={styles.FirstText}>Select payment method</p>
        </div>
            <div className={styles.topBox}>
            <div className={styles.totalCont}>
              <h1 className={styles.totalTittle}>Booking details</h1>
              <div className={styles.totalBox}>
                <div className={styles.eachCont}>
                  <h1 className={styles.eachName}>Destination</h1>
                  <h1 className={styles.eachValue}>{country}</h1>
                </div>
                <div className={styles.eachCont}>
                  <h1 className={styles.eachName}>Visa type</h1>
                  <h1 className={styles.eachValue}>{visa_type}</h1>
                </div>
                <div className={styles.eachCont}>
                  <h1 className={styles.eachName}>Travel date</h1>
                  <h1 className={styles.eachValue}>{travel_date}</h1>
                </div>
                <div className={styles.eachCont}>
                  <h1 className={styles.eachName}>Priority</h1>
                  <h1 className={styles.eachValue}>{service}</h1>
                </div>
                <div className={styles.eachCont}>
                  <h1 className={styles.eachName}>Service charges</h1>
                  <h1 className={styles.eachValue}>₦ {service_fees.toLocaleString()}</h1>
                </div>
                <div className={styles.eachCont}>
                  <h1 className={styles.eachName}>Embassy visa fees</h1>
                  <h1 className={styles.eachValue}>₦ {embassy_fees.toLocaleString()}</h1>
                </div>
                <div className={styles.eachCont}>
                  <h1 className={styles.eachName}>No of persons</h1>
                  <h1 className={styles.eachValue}>{persons}</h1>
                </div>
              </div>
              <hr />
              <div className={styles.totalEnd}>
                <h1 className={styles.total}>Total</h1>
                <h1 className={styles.total}>₦ {total.toLocaleString()}</h1>
              </div>
            </div>
    
            <div className={styles.paymentBox}>
              {/* <h1 className={styles.loginHeading}>Select payment method</h1> */}
              <div className={styles.selectMethodBox}>
                <button
                  className={styles.selectBtn}
                  onClick={() => {
                    setBank("interSwitch");
                  }}
                >
                    <Radio
                    onChange={() => {
                      setBank("interSwitch");
                    }}
                    checked={bank === "interSwitch"}
                    value="normal"
                    color="default"
                    name="bank"
                  />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <img src={bank1} alt="Bank 1" className={styles.btnImage} />  
                </button>
                <button
                  className={styles.selectBtn}
                  onClick={() => {
                    setBank("paystack");
                  }}
                >
                  <Radio
                    onChange={() => {
                      setBank("paystack");
                    }}
                    checked={bank === "paystack"}
                    value="normal"
                    color="default"
                    name="bank"
                  />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <img src={bank2} alt="Bank 2" className={styles.btnImage} />
                </button>
                <button
                  className={styles.selectBtn}
                  onClick={() => {
                    setBank("flutterwave");
                  }}
                >
                  <Radio
                    onChange={() => {
                      setBank("flutterwave");
                    }}
                    checked={bank === "flutterwave"}
                    value="normal"
                    color="default"
                    name="bank"
                  />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <img src={bank3} alt="Bank 3" className={styles.btnImage} />
                </button>
                <button
                  className={styles.selectBtn}
                  onClick={() => {
                    setBank("manual");
                  }}
                >
                  <Radio
                    onChange={() => {
                      setBank("manual");
                    }}
                    checked={bank === "manual"}
                    value="normal"
                    color="default"
                    name="bank"
                  />
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <img src={bank4} alt="Bank 4" className={styles.btnImage} />
                </button>
              </div>
              <div className={styles.signUpbtnCont}>
                <button class={styles.backbtn} onClick={()=>{history.push('/dashboard/plan-a-trip/processing-time')}}><img src={lessthan} alt="Back" /> Back</button>
                <button
                  className={styles.paybtn}
                  onClick={() => pay()}
                  ref={payBtn}
                >
                  {loading ? (
                    <div class="spinner-border" role="status"></div>
                  ) : (
                    `Pay NGN ${total.toLocaleString()}`
                  )}
                </button>
              </div>
            </div>
          </div>
          </>


      </div>
      <ToastContainer
        transition={Slide}
        position="bottom-left"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        className={styles.toasst}
      />
    </div>
  );
}

const mapStateToProps = (state) => ({
  login: state.Login.login,
  details: state.Details.details,
});

const mapDispatchToProp = (dispatch) => ({
  ChangeDetails: (details) => dispatch(changeDetails(details)),
  ChangeLogin: (login) => dispatch(changeLogin(login)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProp
)(PlanATripPaymentMain);
